<div class="button-row">
    <button class="button button--previous" (click)="prev()">&larr; Anterior</button>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <button class="button button--next" (click)="next()">Siguiente &rarr;</button>
</div>

<div id="js-carousel-portadaImg" class="carousel-portada js-carousel-portada w-full lg:rounded-xl md:rounded-br-xl sm:rounded-br-md md:rounded-tr-xl sm:rounded-tr-md rounded-tr-md rounded-br-md overflow-hidden">
    <div class="js-carousel-cell w-full h-full md:h-auto">
        <div class="relative w-full h-full block">
            <img src="https://dummyimage.com/1920x549/b5b5b5/000000.jpg?text=1" />
        </div>
    </div>
    <div class="js-carousel-cell w-full h-full md:h-auto">
        <div class="relative w-full h-full block">
            <img src="https://dummyimage.com/1920x549/b5b5b5/000000.jpg?text=2" />
        </div>
    </div>
    <div class="js-carousel-cell w-full h-full md:h-auto">
        <div class="relative w-full h-full block">
            <img src="https://dummyimage.com/1920x549/b5b5b5/000000.jpg?text=3" />
        </div>
    </div>
</div>

<div id="js-carousel-portada" class="carousel-portada-cells js-carousel-portada mt-2 sm:mt-2 -mx-1 sm:-mx-2 mb-10">
    <button class="js-carousel-cell carousel-portada-cell w-1/2 md:w-1/3 lg:w-1/4 2xl:w-1/4 px-1 sm:p-2 group">
        <img src="https://dummyimage.com/1920x549/b5b5b5/000000.jpg?text=1" />
    </button>
    <button class="js-carousel-cell carousel-portada-cell w-1/2 md:w-1/3 lg:w-1/4 2xl:w-1/4 px-1 sm:p-2 group">
        <img src="https://dummyimage.com/1920x549/b5b5b5/000000.jpg?text=2" />
    </button>
    <button class="js-carousel-cell carousel-portada-cell w-1/2 md:w-1/3 lg:w-1/4 2xl:w-1/4 px-1 sm:p-2 group">
        <img src="https://dummyimage.com/1920x549/b5b5b5/000000.jpg?text=3" />
    </button>
</div>
